




















































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketMcuGigiMulut from "@/store/modules/SuketMcuGigiMulut";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import {
  SuketBaseWithRelationship,
  ContentInterface
} from "@/types/suket_mcu_gigi_mulut";

import pdf from "vue-pdf";

const ICD10 = /^[A-Z][0-9]{2}(\.[0-9]{1,2})?$/;

function emptyContent(): ContentInterface {
  return {
    jenis_mcu: null,
    tujuan_mcu: null,
    instansi_pengirim: null,
    alamat_type: "ktp",
    anamnesis: {
      keluhan_utama: null,
      asimptomatik: false,
      riwayat_sistemik: {
        hipertensi: null, dm: null, jantung: null, paru: null,
        ginjal: null, hati: null, darah: null, tiroid: null,
        hamil_menyusui: null, lain: null
      },
      alergi: {
        anestesi_lokal: null, anestesi_lokal_detail: null,
        obat: null, lateks: null, bahan_dental: null
      },
      obat_saat_ini: {
        antikoagulan: false, bisfosfonat: false,
        imunosupresan: false, ccb: false, rutin_lain: null
      },
      riwayat_dental: {
        kunjungan_terakhir: null, gigi_tiruan: null,
        pesawat_ortodonti: null, trauma: null
      },
      kebiasaan: {
        frekuensi_sikat: null, pasta_fluoride: null,
        bruxism: null, merokok: null, sirih: null, alkohol: null
      }
    },
    vital: {
      kesadaran: "sadar", td_sistolik: null, td_diastolik: null,
      nadi: null, rr: null, suhu: null, spo2: null,
      bb: null, tb: null, gds: null
    },
    ekstra_oral: {
      wajah: { simetri: null, deskripsi: null, profil_lateral: null, pembengkakan: null, lesi_kulit: null },
      kgb: {
        submental: null, submandibular_ka: null, submandibular_ki: null,
        cervical_ka: null, cervical_ki: null, supraclavicular: null, karakteristik: null
      },
      bibir: { narasi: null, warna: null, tekstur: null, lesi: null, kompetensi: null },
      tmj: { nyeri_ka: null, nyeri_ki: null, bunyi: null, deviasi: null, max_opening_mm: null, trismus: null },
      otot_mastikasi: {}
    },
    intra_oral: {
      mukosa_bukal_ka: null, mukosa_bukal_ki: null,
      vestibulum_atas: null, vestibulum_bawah: null,
      frenulum_labialis_atas: null, frenulum_labialis_bawah: null,
      frenulum_bukalis: null, frenulum_lingualis: null,
      dasar_mulut: null, palatum_durum: null, torus_palatinus: null,
      torus_mandibularis: null, celah_palatum: null,
      palatum_molle: null, uvula: null, tonsil: null, tonsil_grade: null,
      orofaring: null, mallampati: null
    },
    lidah: {
      narasi: null, ukuran: null, warna: null, lapisan: null, kelembaban: null,
      fissured: null, geographic: null, hairy: null,
      lateral_ka: null, lateral_ki: null, lesi_lateral: null,
      fungsi_protrusi: null, pengecapan: null
    },
    periodontal: {
      gingiva_narasi: null, warna: null, kontur: null, konsistensi: null,
      tekstur: null, pigmentasi: null,
      bop_sites_positif: null, bop_sites_total: null,
      perdarahan_spontan: null, probing_max_mm: null,
      cpitn: {
        sextant1: null, sextant2: null, sextant3: null,
        sextant4: null, sextant5: null, sextant6: null
      },
      mobilitas_grade_max: null, mobilitas_count_pathological: null,
      ohis_array: [
        { tooth: "16", examined: false, debris: 0, calculus: 0 },
        { tooth: "11", examined: false, debris: 0, calculus: 0 },
        { tooth: "26", examined: false, debris: 0, calculus: 0 },
        { tooth: "36", examined: false, debris: 0, calculus: 0 },
        { tooth: "31", examined: false, debris: 0, calculus: 0 },
        { tooth: "46", examined: false, debris: 0, calculus: 0 }
      ],
      ai_2017: { stage: null, grade: null, extent: null },
      diagnosis_periodontal: null
    },
    kel_ludah: {
      parotid: { sekresi_stensen: null, sialolithiasis: "tidak", palpasi: null },
      submandibular: { sekresi_wharton: null, sialolithiasis: "tidak", sialadenitis: "tidak" },
      sublingual: { ranula: "tidak" },
      minor: { mukokel: "tidak" },
      xerostomia: { sensasi: null, konsistensi: null }
    },
    odontogram: {
      narasi_umum: null,
      dmf_t: { d: 0, m: 0, f: 0 },
      def_t: { d: 0, e: 0, f: 0 },
      pufa: { p: 0, u: 0, f: 0, a: 0 },
      total_gigi_hadir: null, total_gigi_hilang: null,
      anomali: { impaksi: null }
    },
    oklusi: {
      angle_molar_ka: null, angle_molar_ki: null,
      caninus_ka: null, caninus_ki: null,
      overjet_mm: null, overbite_mm: null,
      crossbite_anterior: "tidak", crossbite_posterior: "tidak",
      openbite: null, crowding: null, crowding_lokasi: null,
      spacing: null, midline: null, diagnosis_maloklusi: null
    },
    radiologi: {
      dilakukan: false, jenis: [], tanggal: null,
      operator_radiografer: null, dokter_pembaca: null,
      indikasi_klinis: null, opg: {},
      kesimpulan_radiologi: null, rekomendasi_lanjut: null
    },
    diagnosis: {
      utama: {
        narasi: null, icd10: null, icd10_text: null, lokasi_fdi: null,
        severity: null, clinical_status: "active",
        verification_status: "confirmed", onset: null, catatan: null
      },
      sekunder: [{ narasi: null, icd10: null, lokasi_fdi: null, severity: null }],
      risk_assessment: {
        karies: null, periodontal: null, erosi: null,
        kanker_oral: null, justifikasi: null
      }
    },
    rencana: {
      urgensi: "routine",
      tindakan_segera: [{ narasi: null, icd9cm: null, gigi: null, indikasi: null }],
      tindakan_elektif: [{ narasi: null, icd9cm: null, gigi: null, sesi: null }],
      preventif: {
        scaling: true, fluoride_topikal: false, sealant: false,
        chx_mouthrinse: false, dhe: true
      },
      rujukan_spesialis_dental: [],
      rujukan_non_dental: null, penunjang_lanjutan: null
    },
    dhe: {
      topik: [], media: ["verbal"], durasi_menit: null,
      pemahaman: null, kebutuhan_edukasi_ulang: false,
      leaflet_diberikan: [], rekomendasi_tertulis: null
    },
    kesimpulan: {
      status_umum: null, narasi: null, temuan_utama: null,
      tindak_lanjut: null, fitness_status: null,
      fitness_justifikasi: null, fitness_restriksi: null,
      fitness_reevaluasi_estimasi: null
    },
    validity: {
      berlaku_hingga: null, kontrol_ulang: "6bln", catatan_next_visit: null
    }
  };
}

@Component({
  components: { CardModalTtd, BaseSuketCard, pdf, PersonAutoComplete }
})
export default class SuketMcuGigiMulutTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["03", "2I", "1A", "1B", "1C", "1D", "1E"];
  suketSvc = new CommonSuket(EnSuketCategory.McuGigiMulut);
  suketStore = StoreSuketMcuGigiMulut;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  content: ContentInterface = emptyContent();

  saving = false;
  loadedRatio = 0;

  // Options
  jenisMcuOpts = [
    { text: "MCU Mandiri", value: "mandiri" },
    { text: "MCU Karyawan", value: "karyawan" },
    { text: "MCU Pra-Kerja", value: "pra_kerja" },
    { text: "MCU CPMI (PMK 11/2025)", value: "cpmi" },
    { text: "MCU Asuransi", value: "asuransi" },
    { text: "MCU Sekolah / Komunitas", value: "sekolah" },
    { text: "MCU Berkala (Lansia)", value: "berkala" }
  ];

  sistemikLabels = {
    hipertensi: "Hipertensi",
    dm: "Diabetes Melitus",
    jantung: "Penyakit Jantung",
    paru: "Penyakit Paru (asma/PPOK/TB)",
    ginjal: "Penyakit Ginjal",
    hati: "Penyakit Hati / Hepatitis",
    darah: "Kelainan Darah",
    tiroid: "Kelainan Tiroid"
  };

  sistemikOpts = [
    { text: "Tidak", value: "tidak" },
    { text: "Ya, terkontrol", value: "ya_terkontrol" },
    { text: "Ya, tidak terkontrol", value: "ya_tidak_terkontrol" },
    { text: "Tidak tahu", value: "tidak_tahu" }
  ];

  yaTidakTahuOpts = ["tidak", "ya", "tidak_tahu"];

  kunjunganOpts = ["<6bln", "6_12bln", "1_2thn", ">2thn", "belum_pernah"];
  gigiTiruanOpts = ["tidak", "gtl", "gtsl", "gtc", "implant"];
  orthodontiOpts = ["tidak", "sedang", "selesai", "lepas_dini"];
  freqSikatOpts = ["<1", "1", "2", ">=3"];
  merokokOpts = ["tidak_pernah", "berhenti", "aktif"];
  alkoholOpts = ["tidak", "kadang", "sering"];

  kesadaranOpts = ["sadar", "verbal", "nyeri", "unresponsive"];

  cpitnOpts = ["0", "1", "2", "3", "4", "X"];

  angleOpts = ["I", "II_div1", "II_div2", "III"];

  modalitasOpts = ["opg", "periapikal", "bitewing", "occlusal", "ceph", "tmj", "cbct"];

  clinicalStatusOpts = ["active", "recurrence", "relapse", "inactive", "remission", "resolved"];
  verifyStatusOpts = ["unconfirmed", "provisional", "differential", "confirmed", "refuted"];
  risikoOpts = ["rendah", "sedang", "tinggi"];
  urgensiOpts = [
    { text: "Routine (elektif)", value: "routine" },
    { text: "Urgent (≤7 hari)", value: "urgent" },
    { text: "ASAP (segera)", value: "asap" },
    { text: "STAT (emergency)", value: "stat" }
  ];

  rujukanDentalOpts = [
    { text: "Sp.KG (Konservasi/Endodonti)", value: "sp_kg" },
    { text: "Sp.Perio (Periodonsia)", value: "sp_perio" },
    { text: "Sp.Pros (Prostodonsia)", value: "sp_pros" },
    { text: "Sp.Ort (Ortodonsia)", value: "sp_ort" },
    { text: "Sp.BM (Bedah Mulut & Maksilofasial)", value: "sp_bm" },
    { text: "Sp.PM (Penyakit Mulut)", value: "sp_pm" },
    { text: "Sp.KGA (KG Anak)", value: "sp_kga" },
    { text: "Sp.RKG (Radiologi KG)", value: "sp_rkg" },
    { text: "Sp.KGM (KG Masyarakat)", value: "sp_kgm" }
  ];

  dheTopikOpts = [
    { text: "Teknik menyikat gigi (Bass / Modified Bass)", value: "teknik_sikat" },
    { text: "Frekuensi & durasi (2× sehari, ≥2 menit)", value: "frekuensi_durasi" },
    { text: "Pemilihan sikat (soft bristle)", value: "pemilihan_sikat" },
    { text: "Pasta berfluoride (1000–1500 ppm)", value: "pasta_fluoride" },
    { text: "Flossing & interdental brush", value: "floss" },
    { text: "Mouthrinse (CHX / fluoride)", value: "mouthrinse" },
    { text: "Tongue cleaning", value: "tongue_cleaning" },
    { text: "Diet & kariogenik", value: "diet_kariogenik" },
    { text: "Diet & erosi (asam/soda)", value: "diet_erosi" },
    { text: "Berhenti merokok", value: "berhenti_rokok" },
    { text: "Pengurangan sirih / alkohol", value: "sirih_alkohol" },
    { text: "Pencegahan trauma (mouthguard)", value: "trauma_olahraga" },
    { text: "Kontrol berkala 6 bulan", value: "kontrol_6bln" },
    { text: "Self-exam oral cancer", value: "self_exam_oral_cancer" },
    { text: "Manajemen bruxism / nightguard", value: "manajemen_bruxism" },
    { text: "Edukasi laktasi & gigi anak", value: "laktasi_gigi_anak" },
    { text: "Edukasi ibu hamil", value: "ibu_hamil" }
  ];

  statusUmumOpts = [
    { text: "Baik", value: "baik" },
    { text: "Cukup", value: "cukup" },
    { text: "Kurang", value: "kurang" },
    { text: "Buruk", value: "buruk" }
  ];

  fitnessOpts = [
    { text: "FIT (Layak)", value: "FIT" },
    { text: "FIT WITH RESTRICTION (Layak dengan Catatan)", value: "FIT WITH RESTRICTION" },
    { text: "TEMPORARILY UNFIT (Tidak Layak Sementara)", value: "TEMPORARILY UNFIT" },
    { text: "UNFIT (Tidak Layak)", value: "UNFIT" }
  ];

  kontrolUlangOpts = [
    { text: "3 bulan", value: "3bln" },
    { text: "6 bulan", value: "6bln" },
    { text: "1 tahun", value: "1thn" }
  ];

  // Rules
  rRequired = [(v: any) => (v !== null && v !== undefined && v !== "") || "*Kolom ini harus diisi"];
  rRequiredNumber = [(v: any) => (typeof v === "number" && !isNaN(v)) || "*Wajib angka"];
  rRequiredArray = [(v: any) => (Array.isArray(v) && v.length > 0) || "*Pilih minimal 1"];
  rIcd10 = [
    (v: any) => !!v || "*Kode ICD-10 wajib",
    (v: any) => ICD10.test(v || "") || "Format ICD-10 tidak valid (mis. K02.1)"
  ];
  rJustifikasi = [
    (v: any) => !!v || "*Justifikasi klinis wajib (KODEKI Psl 7)",
    (v: any) => (v || "").length >= 50 || "Minimal 50 karakter"
  ];
  rRequiredMin(n: number) {
    return [
      (v: any) => !!v || "*Wajib diisi",
      (v: any) => (v || "").length >= n || `Minimal ${n} karakter`
    ];
  }

  mounted() {
    this.fillFromData(this.dataSuket);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get jenisKelamin() {
    if (this.pasien.jk === "L") return "Laki-laki";
    if (this.pasien.jk === "P") return "Perempuan";
    return this.pasien.jk || "-";
  }

  get alamatOpts() {
    const opts: any[] = [
      { id: "ktp", name: "Alamat KTP — " + (this.pasien.alamat || "-") }
    ];
    if ((this.pasien as any).alamat_domisili) {
      opts.push({ id: "domisili", name: "Alamat Domisili — " + (this.pasien as any).alamat_domisili });
    }
    return opts;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.McuGigiMulut, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: this.content,
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  // Preview labels (FE-only display; server tetap source of truth)
  get bopPreviewLabel() {
    const pos = Number(this.content.periodontal.bop_sites_positif || 0);
    const tot = Number(this.content.periodontal.bop_sites_total || 0);
    if (!tot) return "-";
    const p = Math.round((pos / tot) * 1000) / 10;
    let interp = "sehat (<10%)";
    if (p > 30) interp = "gingivitis berat (>30%)";
    else if (p >= 10) interp = "gingivitis ringan (10–30%)";
    return `${p}% — ${interp}`;
  }

  get cpitnPreviewLabel() {
    const sx = this.content.periodontal.cpitn;
    const vals = [sx.sextant1, sx.sextant2, sx.sextant3, sx.sextant4, sx.sextant5, sx.sextant6]
      .filter(v => v && v !== "X")
      .map(v => parseInt(v as string, 10));
    if (!vals.length) return "-";
    const max = Math.max(...vals);
    const tn = ["TN0 (tidak perlu)", "TN1 (DHE)", "TN2 (DHE+Scaling)", "TN3 (DHE+Scaling+Terapi kompleks)", "TN3 (DHE+Scaling+Terapi kompleks)"][max];
    return `Max ${max} — ${tn}`;
  }

  get ohisPreviewLabel() {
    const arr = this.content.periodontal.ohis_array;
    let dSum = 0, cSum = 0, n = 0;
    for (const t of arr) {
      if (t.examined) {
        dSum += Number(t.debris || 0);
        cSum += Number(t.calculus || 0);
        n++;
      }
    }
    if (!n) return "-";
    const di = Math.round((dSum / n) * 100) / 100;
    const ci = Math.round((cSum / n) * 100) / 100;
    const total = Math.round((di + ci) * 100) / 100;
    let interp = "Baik";
    if (total > 3.0) interp = "Buruk";
    else if (total > 1.2) interp = "Sedang";
    return `DI-S ${di} + CI-S ${ci} = ${total} (${interp})`;
  }

  get dmftPreviewLabel() {
    const d = Number(this.content.odontogram.dmf_t.d || 0);
    const m = Number(this.content.odontogram.dmf_t.m || 0);
    const f = Number(this.content.odontogram.dmf_t.f || 0);
    const t = d + m + f;
    let interp = "Sangat rendah";
    if (t > 6) interp = "Sangat tinggi";
    else if (t > 4) interp = "Tinggi";
    else if (t > 2) interp = "Sedang";
    else if (t > 1) interp = "Rendah";
    return `Total ${t} (${interp})`;
  }

  fillFromData(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = (val.pasien as any)?.umur_th || this.umur;
      this.surat_date = (val.surat_date as any) ?? new Date();
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      // merge content (preserve defaults for missing keys)
      this.content = { ...emptyContent(), ...((val.content as any) || {}) } as ContentInterface;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.content = emptyContent();
    }
  }

  addDxSekunder() {
    this.content.diagnosis.sekunder.push({ narasi: null, icd10: null, lokasi_fdi: null, severity: null });
  }
  removeDxSekunder(i: number) {
    this.content.diagnosis.sekunder.splice(i, 1);
  }
  addTindakanSegera() {
    this.content.rencana.tindakan_segera.push({ narasi: null, icd9cm: null, gigi: null, indikasi: null });
  }
  removeTindakanSegera(i: number) {
    this.content.rencana.tindakan_segera.splice(i, 1);
  }
  addTindakanElektif() {
    this.content.rencana.tindakan_elektif.push({ narasi: null, icd9cm: null, gigi: null, sesi: null });
  }
  removeTindakanElektif(i: number) {
    this.content.rencana.tindakan_elektif.splice(i, 1);
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan MCU Gigi & Mulut");
        this.close();
        StoreSuketMcuGigiMulut.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    this.fillFromData(val);
  }
}
